import { useAppDispatch, useAppSelector } from '~/store/hooks'

import { updateRoof } from 'store/objects'
import { mostRecentSelectedObjectOfClassName } from 'store/selectedObjects/selectors'
import { SELECTED_ROOF_PANEL } from 'store/panel/types'
import CLASS_NAMES from 'config/objectClassNames'
import theme from 'config/theme'

import Panel, { PanelSection } from 'components/UIKit/Panel'
import { ColorPicker } from 'react-aria-components'
import { SwatchWell } from '~/ui/Color'
import { Label } from '~/ui/Field'
import { Roof } from '~/store/objects/types'
import { MetadataFields } from '~/components/MetadataFields'

export default function SelectedRoofPanel() {
  const roof: Roof | undefined = useAppSelector(it => mostRecentSelectedObjectOfClassName(CLASS_NAMES.ROOF, it))
  const dispatch = useAppDispatch()
  const update = (roof: Roof) => dispatch(updateRoof({ roof }))

  return (
    <Panel title="Roof" alignment="right" docked panelKey={SELECTED_ROOF_PANEL}>
      {roof && (
        <>
          <PanelSection>
            <ColorPicker
              value={typeof roof.color === 'number' ? theme.colors.three.objects.roof.default : roof.color}
              onChange={color => update({ ...roof, color: color.toString('hex') })}
            >
              <Label>Color</Label>
              <SwatchWell swatches={theme.colors.swatches} />
            </ColorPicker>
          </PanelSection>
          <MetadataFields
            onChange={(fieldName, newValue) => {
              dispatch(updateRoof({ roof: { ...roof, metadata: { ...roof.metadata, [fieldName]: newValue } } }))
            }}
            onDeleteImage={updatedRoof => dispatch(updateRoof({ roof: updatedRoof }))}
            selectedObjects={[roof]}
          />
        </>
      )}
    </Panel>
  )
}
